import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { ItemReference } from 'stores/dataStore';
import { NewEventRequestChangeStore } from 'stores/events/event-request-changes-store';
import './request-changes-popup.less'; // si tienes estilos adicionales
import TailwindMessage from 'site/pages/landing-pages/mobile/alerts/message-tw';

export interface TailwindRequestChangesPopupProps extends WithTranslation {
  open: boolean;
  eventId: string;
  onCancelClicked: () => void;
  onSendClicked?: () => void;
  newEventRequestChange?: NewEventRequestChangeStore;
}

interface TailwindRequestChangesPopupState {
  reason: ItemReference;
  comments: string;
  loading: boolean;
}

@connect(['newEventRequestChange', NewEventRequestChangeStore])
class TailwindRequestChangesPopup extends React.Component<TailwindRequestChangesPopupProps, TailwindRequestChangesPopupState> {
  private get store() {
    return this.props.newEventRequestChange;
  }

  constructor(props: TailwindRequestChangesPopupProps) {
    super(props);
    this.store.createNew();

    this.state = {
      reason: null,
      comments: '',
      loading: false
    };
  }

  private onRequestChangesSent = async () => {
    this.store.change({
      comments: this.state.comments,
      reasonId: this.state.reason ? this.state.reason.id : null
    });
    this.setState({ loading: true });

    await this.store.createEventRequestChange(this.props.eventId);

    if (this.store.state.result?.isSuccess) {
      this.store.clear();
      this.setState({ reason: null, comments: '', loading: false });
      this.props.onSendClicked?.();
    } else {
      this.setState({ loading: false });
    }
  };

  private onCancel = () => {
    this.setState({ reason: null, comments: '' });
    this.props.onCancelClicked();
  };

  private handleValue = (prop: string, value: any) => {
    (this.setState as any)({ ...this.state, [prop]: value });
  };

  public render() {
    const { t, open } = this.props;
    const { comments, loading } = this.state;

    if (!open) return null;

    const errors =
      this.store.state.result && !this.store.state.result.isSuccess && this.store.state.result.messages.length > 0 ? (
        <TailwindMessage
          error
          icon="exclamation-circle"
          header={t('An error ocurred')}
          list={this.store.state.result.messages.map(o => o.body)}
          className="mb-4"
        />
      ) : null;

    return (
      <div
        className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm"
        style={{
          paddingLeft: '56px',
          paddingRight: '16px'
        }}
      >
        <div className="bg-white rounded-lg border border-gray-300 shadow-2xl w-full max-w-sm p-4 relative">
          {/* Botón Back */}
          <button onClick={this.onCancel} className="flex items-center gap-1 text-sm text-black-600 mb-2">
            ← {t('Back')}
          </button>

          {/* Errores */}
          {errors}

          <h3 className="text-lg font-semibold mb-4">{t('You are Requesting Changes in this Event.')}</h3>
          <p className="text-sm text-gray-700 mb-4">{t('Please, write down the reason for the change, or any comment related to it.')}</p>

          {/* Campo comentarios */}
          <textarea
            required
            className="w-full p-2 border border-gray-300 rounded mb-4"
            value={comments}
            onChange={e => this.handleValue('comments', e.target.value)}
            placeholder={t('Reason / Comments')}
            rows={4}
          />

          {/* Botones */}
          <button className="w-full bg-gray-200 text-black py-2 rounded mt-2" onClick={this.onCancel} disabled={loading}>
            {t('Cancel')}
          </button>

          <button
            className="w-full bg-primary-600 text-white py-2 rounded mt-2 disabled:opacity-50"
            onClick={this.onRequestChangesSent}
            disabled={loading || !comments}
          >
            {loading ? t('Sending...') : t('Send')}
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(TailwindRequestChangesPopup);
